// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__JADN0","ttl":"styles_ttl__JYiKY","txt":"styles_txt__Kp3nF","btn":"styles_btn__+HgVk","info":"styles_info__-AD5r","info__item":"styles_info__item__yvapy"};